import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { CommonService } from '../../../../services/common';
import { VaultStateService } from '../../../services/vault-state.service';
import { environment } from '../../../../../environments/environment';
import { IconList } from '../../../../../iconlist';
import { formatCurrency, formatDate } from '@angular/common';

@Component({
  selector: 'app-vault-pay-list',
  templateUrl: './vault-pay-list.component.html',
  styleUrl: './vault-pay-list.component.scss'
})
export class VaultPayListComponent implements OnInit {
  @Input() vaultPayListData: any;
  @Output() changeModelStatus = new EventEmitter<any>();

  selectedExportData: any[] = [];
  columnDefs: any[] = [];


  addIcon: string = environment.assetsImagePath + IconList.AddbuttonIcon
  editIcon: string = environment.assetsImagePath + IconList.EditIconDropdown
  cancelIcon = environment.assetsImagePath + IconList.AllotmentCancelIcon

  constructor(public commonService: CommonService, private vaultService: VaultStateService) {
  }

  ngOnInit(): void {
    this.initializeColumnDefs();
  }

  initializeColumnDefs() {
    this.columnDefs = [
      {
        field: 'selection', columnType: 'checkbox'
      },
      { field: 'transDate', header: 'Payment Date', columnType: 'date', config: { dateFormat: "dd-MMM-yyyy" } },
      { field: 'Sender', header: 'Sender', columnType: 'text' },
      { field: 'amount', header: 'Amount', columnType: 'amount', config: { 'decimals': 0 } },
      { field: 'transRefType', header: 'Transaction Type', columnType: 'text' },
      { field: 'remark', header: 'Remark', columnType: 'text', maxTextLength: 50, tooltipField: 'remark' },
    ]
  }


  onCommonTableDropdownChange(event: any) {
  }

  onSelectedRowsChange(event: any) {
    this.selectedExportData = event;
  }

  changeAddUpdateModalState(currentRecord?: any, context?: string) {
    // always update currentBooking
    this.changeModelStatus.emit({
      "showaddUpdateModal": true,
      "currentSelectedRecord": currentRecord,
      context: context,
      "vaultPayListData": this.vaultPayListData
    });
    this.commonService.setActionType(context);
    // this.vaultService.$currentBookingChanged.next(this.salesService.currentBooking);
  }
}
